import { useContext } from "react";
import FileDownloadedNotificationV1 from "./FileDownloadedNotificationV1";
import FileDownloadedNotificationV2 from "./FileDownloadedNotificationV2";
import { FeatureToggleContextV2 } from "../../../../../../../../context/FeatureToggleContextV2/FeatureToggleContextV2";
import {
  CATEGORIES,
  TOGGLES,
} from "../../../../../../../../pages/featureToggles/constants";
import { Notification } from "../../hooks/useNotifications/useNotifications";

export type FileDownloadedNotificationProps = {
  notification: Notification;
  expireNotification?: () => void;
  successMessage: string;
  failureMessage: string;
  downloadFunction: (accessToken: string) => void;
  subMessage?: string;
};

// Once V2 is stable, we can shift V2 here and delete the version components
const FileDownloadedNotification = (props: FileDownloadedNotificationProps) => {
  const { isToggleEnabled } = useContext(FeatureToggleContextV2);

  const isAppNotificationsEnabled = isToggleEnabled(
    CATEGORIES.ALERTS_SERVICE,
    TOGGLES.ENABLE_ALERTS_AND_NOTIFICATIONS
  );

  return isAppNotificationsEnabled ? (
    <FileDownloadedNotificationV2 {...props} />
  ) : (
    <FileDownloadedNotificationV1 {...props} />
  );
};

export default FileDownloadedNotification;
